
const signUpSchema = () => {
  return {
    first_name: {
      presence: {
        allowEmpty: false,
        message: '^لطفا نام خود را وارد کنید'
      },
      length: {
        maximum: 20,
        message: '^نام حداکثر می‌تواند ۲۰ کاراکتر باشد.'
      }
    },
    last_name: {
      presence: {
        allowEmpty: false,
        message: '^لطفا نام خانوادگی خود را وارد کنید.'
      },
      length: {
        maximum: 20,
        message: '^نام خانوادگی حداکثر می‌تواند ۲۰ کاراکتر باشد.'
      }
    },
    gender: {
      presence: {
        allowEmpty: false,
        message: ''
      }
    },
    otp: {
      presence: {
        allowEmpty: false,
        message: '^لطفا کد تایید خود را وارد کنید.'
      },
      length: {
        is: 6,
        message: '^کد تایید وارد شده صحیح نیست.'
      }
    }
  }
}

export default signUpSchema
